export enum Routes {
  PRICING = "/pricing",
  CHECKOUT = "checkout",
  EXTRA_SERVICES = "extra-services",
  MAKE_PAYMENT = "make-payment",
  MAKE_SERVICE_PAYMENT = "make-service-payment",
  LOGIN = "sign-in",
  VERIFY = "verify",
  TEMPORARY_PAGE = "temporary-page",
  ACTIVATE = "activate",
  PROFILE_VERIFY = "verify-profile",
  VERIFY_SCHOOL = "verify-school",
  REGISTER = "sign-up",
  REGISTER_STUDENT = "sign-up/student",
  REGISTER_PARENT = "sign-up/parent",
  REGISTER_TEACHER = "sign-up/teacher",
  REGISTER_AGENT = "sign-up/agent",
  REGISTER_SCHOOL = "sign-up/school",
  REGISTER_SERVICE_PROVIDER = "sign-up/service-provider",
  SUBSCRIBE = "subscribe",
  RESET_PASSWORD = "reset-password",
  FORGOT_PASSWORD = "forgot-password",
  MY_ACCOUNT = "my-account",
  EMAIL_PREFERENCES = "email-preferences",

  APPLY = "application/create/:programId/:majorId",
  SHOW_APPLICATION = "application/:applicationId",
  EDIT_APPLICATION = "application/:applicationId/edit",
  APPLY_LIST = "application",
  APPLY_HISTORY = "application/history",

  SCHOOLS = "school",
  SCHOOL_BRANCH = "school/:id/branch",
  SCHOOL_FAVORITES = "school/favorites",

  PROGRAMS = "program",
  VIEW_PROGRAM = "program/:typeId/:id",

  PRIVATE_CLASSES = "private-classes",

  LANGUAGE_COURSES = "language-course",
  VIEW_COURSE = "language-course/:id",

  STUDENTS = "student",
  STUDENT = "student/:id",

  DEGREES = "degree",
  APPLICATIONS = "application",
  EXAMS = "exam",
  MAJORS = "major",
  SERVICES_ADMIN = "services",
  SERVICE_LIST = "service-list",
  SERVICES = "service",
  ACADEMICS = "academic",
  BRANCHES = "branch",
  USERS = "user",
  ADMINS = "user/admin",
  USER_STUDENTS = "user/student",
  AGENTS = "user/agent",
  PARENTS = "user/parent",
  SCHOOL_LIST = "user/school",
  SERVICE_PROVIDER_LIST = "user/service-provider",
  BILLING = "billing",
  MESSAGES = "message",
  STATISTICS = "statistics",
  BROADCAST = "broadcast",
  USER_MESSAGES = "message/:userRole/:recipientId",

  AGENT_GUIDE = "https://cdn.worlded.us/assets/user-manuals/guide_agent.pdf",
  HIGHER_SCHOOL_GUIDE = "https://cdn.worlded.us/assets/user-manuals/guide_higher_education.pdf",
  SECONDARY_SCHOOL_GUIDE = "https://cdn.worlded.us/assets/user-manuals/guide_secondary_education.pdf",
}
